/************************************************************************
 ** IBM Confidential
 **
 ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
 **
 ** (C) Copyright IBM Corp. 2022
 **
 ** The source code for this program is not published or otherwise divested of its trade secrets, 
 ** irrespective of what has been deposited with the U.S. Copyright Office.
 ************************************************************************/
// GENERATED
import GenericClientUtils from './GenericClientUtils';
import FileSource from './FileSource';
import DatabaseSource from './DatabaseSource';
//@import com/ibm/bi/platform/moser/client/utils/GenericClientUtils (loadtime) // superclass
//@import com/ibm/bi/platform/moser/client/cde/FileSource (runtime) // new
//@import com/ibm/bi/platform/moser/client/cde/DatabaseSource (runtime) // new

/**
 * Utility to work on old cde dashboard data sources in order to faciliate conversion REST calls from MUI to modeling service
 * @author  nbalaba
 */
export default class CDEConverterUtil extends GenericClientUtils{

	static MODULE = "module";

	static JDBC = "jdbc";



	/**
	 * Sort sources from old cde dashboard to identify single source of data - tables from the same schema are consolidated into one datasource
	 * @param {Array} sources
	 * @return {Object}  sorted sources - one per actual source
	 */
	sortCDESources(sources) {
		var sorted = {};
		for (var __i_enFor0 = 0, __exp_enFor0 = sources, __len_enFor0 = __exp_enFor0.length;
				__i_enFor0 < __len_enFor0; ++__i_enFor0) {
			var source = __exp_enFor0[__i_enFor0];
			var datasource = this._createDatasource(source);
			if (datasource.isFile()) {
				sorted[datasource.getUniqueKey()] = datasource.toJSON();
			} else {
				var databaseSource = sorted[datasource.getUniqueKey()];
				if (!databaseSource) {
					sorted[datasource.getUniqueKey()] = datasource.toJSON();
				} else {
					(databaseSource["sources"]).push(source);
				}
			}
		}
		return sorted;
	}

	/**
	 * @param {Object} source
	 * @return {Source}
	 */
	_createDatasource(source) {
		var module = source["module"];
		var module_source = module["source"];
		var id = module_source["id"].toString();
		if (this.isDatabase(source)) {
			var db_source = this.initDatabaseSource(id);
			db_source.getSources().push(source);
			return db_source;
		}
		var parts = id.split(new RegExp(":"));
		var filesource = new FileSource();
		filesource.setProjectId(parts[0]);
		filesource.setAssetId(parts[2]);
		filesource.setSource(source);
		return filesource;
	}

	initDatabaseSource(id) {
		var parts = id.split(new RegExp(":"));
		var db_source = new DatabaseSource();
		db_source.setProjectId(parts[0]);
		db_source.setAssetId(parts[1]);
		var partOne = ":" + parts[0] + ":" + parts[1] + ":";
		var partTwo = id.substring(partOne.length, id.length);
		parts = partTwo.split(new RegExp(":table:"));
		var tableName = parts[parts.length - 1];
		var parts_length = parts[0].length, tableNameLength = tableName.length + 1, index = parts_length - tableNameLength;
		var schema = parts[0].substring(0, index);
		if (schema.length === 0) {
			schema = "null";
		}
		db_source.setSchema(schema);
		return db_source;
	}

	/**
	 * @param {Object} source
	 * @return {boolean}
	 */
	isDatabase(source) {
		var module = source["module"];
		return (module["source"]).hasOwnProperty("jdbc");
	}

	//constructor() 
}


// WEBPACK FOOTER //
// ./src/generated/CDEConverterUtil.js